import { postApi } from '../api/storeFront';
const createCart = async (body, logger) => {
    return postApi(body, '/{userId}/cart', logger);
};
export default createCart;
